import React from 'react';
import './Domains.css';
import { Shield, Radio, Building2, Coins, FlaskConical, PenTool } from 'lucide-react';

const domainCards = [
  {
    id: 'resilience',
    icon: Shield,
    title: 'Resilience',
    description: 'Cybersecurity meets insurance. Building the category.',
    link: 'https://cyberresilience.com',
    testId: 'domain-resilience'
  },
  {
    id: 'usaf-reserve',
    icon: Radio,
    title: 'USAF Reserve',
    description: 'Combat communications. Cyber warfare. National security.',
    link: 'https://squadron.vman747.com',
    testId: 'domain-usaf-reserve'
  },
  {
    id: 'hoover',
    icon: Building2,
    title: 'Hoover Institution',
    description: 'Veteran Fellow 2025–2026 at Stanford.',
    link: 'https://criticalguard.org',
    testId: 'domain-hoover'
  },
  {
    id: 'knowledge-base',
    icon: Coins,
    title: 'Knowledge Base',
    description: 'Key learning themes of interest. Podcasts, explainers, and quality sources.',
    link: 'https://notes.vman747.com',
    testId: 'domain-knowledge-base'
  },
  {
    id: 'lab',
    icon: FlaskConical,
    title: 'Lab',
    description: 'Tools, experiments, side projects. The workshop.',
    link: 'https://fuel.vman747.com',
    testId: 'domain-lab'
  },
  {
    id: 'writing',
    icon: PenTool,
    title: 'Writing',
    description: 'Notes from the intersection of security, policy, and building.',
    link: '#signal',
    testId: 'domain-writing'
  }
];

const Domains = () => {
  return (
    <section className="domains" id="domains" data-testid="domains-section">
      <div className="section-content">
        <h2 className="section-header" data-testid="domains-header">Vectors</h2>

        <div className="domains-grid" data-testid="domains-grid">
          {domainCards.map((card) => {
            const Icon = card.icon;
            const isExternal = card.link.startsWith('http');
            return (
              <a
                key={card.id}
                href={card.link}
                className="domain-card"
                data-testid={card.testId}
                target={isExternal ? '_blank' : '_self'}
                rel={isExternal ? 'noopener noreferrer' : undefined}
                aria-label={`${card.title} — ${card.description}${isExternal ? ' (opens in new tab)' : ''}`}
              >
                <div className="card-icon">
                  <Icon size={24} strokeWidth={1.5} aria-hidden="true" />
                </div>
                <h3 className="card-title">
                  {card.title}
                  {isExternal && <span className="external-indicator" aria-hidden="true"> ↗</span>}
                </h3>
                <p className="card-description">{card.description}</p>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Domains;
